(function() { window.GUID_2b6eb763_ce9a_49fd_8aff_e86aa7a28144 = { getGuid: function() { return "2b6eb763-ce9a-49fd-8aff-e86aa7a28144"; } }; })();
var GeneralSearch;
(function (GeneralSearch) {
    var Desktop;
    (function (Desktop) {
        //Le temps ou le décompte commence a apparaitre avant la fermeture
        //Donc, si j'ai un timeout de 60 entout, le décompte apparaitra a 45 secondes avant la fin
        var timeOutMax = 15;
        var timeOutCount = timeOutMax;
        /*Bouton qui permet de sortir du general search en debug*/
        var hiddenNavOutButton = $('#HiddenNavOutButton');
        var timeOutMessage = $('#TimeOutMessage');
        var timeoutID = null;
        var timeoutmessageID = null;
        Desktop.waitingForTimeOut = false;
        var timeOutInSecond = $('#InactivityTimeOut').val();
        var btnX = $('#SearchBigX');
        var canvasBracket = $('#CanvasBracket');
        var masterContainerOverEverything = $('#MasterContainerOverEverything');
        GeneralSearch.BindElements();
        CS.off('TreeViewIsLoaded', '#TreeViewDivisions', onTreeViewIsLoaded);
        CS.on('TreeViewIsLoaded', '#TreeViewDivisions', onTreeViewIsLoaded);
        function onTreeViewIsLoaded(e, treeView) {
            GeneralSearch.treeViewDivisions = treeView;
            GeneralSearch.treeViewDivisions.TreeViewItemSelected = GeneralSearch.OnTreeViewItemSelected;
        }
        var searchHubConnection;
        $(function () {
            var isDisconnected = false;
            var isReconnected = false;
            var lastTimeout = null;
            var rightSearchColumn = $('#RightSearchColumn');
            var internetConnectionLost = $('#InternetConnectionLost');
            if (GeneralSearch.callFromHomePage != "True") {
                initSignalR();
            }
            // Initialize the connection
            function initSignalR() {
                searchHubConnection = new signalR.HubConnectionBuilder()
                    .withUrl("/signalr/GeneralSearchHub")
                    .withAutomaticReconnect()
                    .build();
                searchHubConnection.start()
                    .then(() => {
                    console.log('SignalR Connection started');
                    searchHubConnection.invoke('joinHub', CSParameters.SportEventId.toString());
                    UpdateIsReconnected();
                })
                    .catch(err => console.error('SignalR Connection Error:', err));
                searchHubConnection.onreconnected(connectionId => {
                    console.log("SignalR reconnected: " + connectionId);
                    UpdateIsReconnected();
                });
                searchHubConnection.onreconnecting(error => {
                    console.log('SignalR reconnecting', error);
                    internetConnectionLost.show();
                    if (!isDisconnected) {
                        isReconnected = false;
                        isDisconnected = true;
                    }
                });
                searchHubConnection.on("updateDivisions", onUpdateDivisions);
                searchHubConnection.on("updateAds", onUpdateAds);
            }
            function onUpdateDivisions() {
                //Temp fix until we figure how to fix the leak
                if (CSParameters.SportEventId != 5162) {
                    var data = {};
                    CompuSport.Ajax.Get(CSParameters.RUrl + "GeneralSearch/SearchInputsDropDown/" + CSParameters.SportEventId.toString(), data, function (queryResult) {
                        rightSearchColumn.html(queryResult);
                        GeneralSearch.treeViewDivisions.Dispose();
                        GeneralSearch.treeViewDivisions = new CS.TreeView("TreeViewDivisions");
                        GeneralSearch.treeViewDivisions.TreeViewItemSelected = GeneralSearch.OnTreeViewItemSelected;
                    });
                }
            }
            ;
            function onUpdateAds() {
                var data = {};
                CompuSport.Ajax.Get(CSParameters.RUrl + "GeneralSearch/IndexPubs/" + CSParameters.SportEventId, data, function (queryResult) {
                    if (document.PubsRotator != undefined && document.PubsRotator.Rotator != null && document.PubsRotator.Rotator.length > 0) {
                        document.PubsRotator.ReplaceContent(queryResult);
                    }
                });
            }
            ;
            function UpdateIsReconnected() {
                isDisconnected = false;
                isReconnected = true;
                internetConnectionLost.hide();
                //Pour éviter un call la premiere fois
                if (lastTimeout != null) {
                    onUpdateDivisions();
                    onUpdateAds();
                }
            }
            if (document.SelectedEntityId != null) {
                //Ici, je bind les éléments qui devront être caché lorsqu'un entité est sélectionné
                document.SelectedEntityId.HideElementWhenOpen = $('iframe');
                document.SelectedEntityId.SelectionChange = function () {
                    GeneralSearch.SelectedEntity(this.val(), null);
                };
            }
            $('#SelectedEntityIdAutoComplete').on('keyup', function (e) {
                if (e.keyCode == 13) {
                    var searchCode = $(this).val();
                    if (searchCode.length > 0) {
                        var num = parseInt(searchCode, 10);
                        if (!isNaN(num)) {
                            e.preventDefault();
                            GeneralSearch.SelectedEntity(null, null, num);
                        }
                    }
                }
            });
            //$('#SelectedEntityId').on('Scanned', function (e) {
            //    var scannedId = $(e.target).data('context').AutoComplete.val();
            //    OnSearchScanned(scannedId);
            //});
            btnX.on('click', function () {
                ClearResult(false);
            });
            GeneralSearch.BindSearchResultsEvents($('#SearchResult'));
            if (GeneralSearch.callFromHomePage == "False") {
                CS.doc.on('mousemove.search', function () {
                    SetTimer();
                }).on('mousedown', function () {
                    SetTimer();
                }).on('mousewheel', function () {
                    SetTimer();
                }).on('keydown', function () {
                    SetTimer();
                });
                CS.body.on('contextmenu', function (e) {
                    e.preventDefault();
                    return false;
                });
            }
            $('#FindBy').on('click', 'a', function (e) {
                e.preventDefault();
                Desktop.waitingForTimeOut = true;
                let popup = new CompuSport.Controls.Popup();
                popup.GetAndShow({
                    PopupId: "FindByPopup",
                    Url: CSParameters.RUrl + "GeneralSearch/FindByPopup/" + CSParameters.SportEventId,
                    AjaxCallType: CompuSport.Ajax.AjaxCallType.GET,
                    ForceFullScreen: true
                });
                popup.OnButtonClicked = function (button, buttonValue) {
                    if (buttonValue == 'Ok') {
                        if (document.GridViewEntityBaseFilteredSearchv2.SelectedRows.length == 1) {
                            var entityId = document.GridViewEntityBaseFilteredSearchv2.GetSelectedRowIds();
                            GeneralSearch.SelectedEntity(entityId);
                        }
                    }
                };
                /*
                ShowFormPopup(CSParameters.RUrl + "GeneralSearch/FindByPopup/" + CSParameters.SportEventId, null, null, null, function () {
                    if (this.ClickedButton == 'Ok') {
                        if (document.GridViewEntityBaseFilteredSearchv2.SelectedRows.length == 1) {
                            var entityId = document.GridViewEntityBaseFilteredSearchv2.GetSelectedRowIds();
                            SelectedEntity(entityId);
                        }
                    }
                }, true, true, "FindByPopupDialog");
                //*/
            });
        });
        function LoadChartDesktop(flowBlockId, isBracket, entityBaseId, extMatchId) {
            var data = {};
            data.flowBlockId = flowBlockId;
            data.highlightedEntityBaseId = entityBaseId;
            data.isBracket = isBracket;
            data.highlightedDrawPosition = null;
            data.highlightedExtMatchId = extMatchId;
            CompuSport.Ajax.Get(CSParameters.RUrl + "Charts/Chart/" + CSParameters.SportEventId, data, function (queryResult) {
                masterContainerOverEverything.slideDown(250, function () {
                    UpdateChart(queryResult, false);
                    RegisterBracketInfoEvents();
                });
            });
        }
        Desktop.LoadChartDesktop = LoadChartDesktop;
        function RegisterBracketInfoEvents() {
            var btnCloseCanvasContainer = $('.CSZoomCanvasControlPanel .Close');
            btnCloseCanvasContainer.off('mousedown');
            btnCloseCanvasContainer.on('mousedown', function (e) {
                e.preventDefault();
                ClearResult(true);
            });
        }
        function ClearResult(justBracket) {
            if (!justBracket) {
                GeneralSearch.SelectedEntity(null, null, null);
                ClearTimers();
                Desktop.waitingForTimeOut = false;
                var currentOpenDialog = $('.ui-dialog');
                if (currentOpenDialog.length > 0) {
                    currentOpenDialog.remove();
                }
            }
            GeneralSearch.shareFacebookEvent.show();
            document.CanvasChart.ClearContent();
            masterContainerOverEverything.slideUp(250, 'swing', function () {
                if (!justBracket) {
                    if (document.PubsRotator != undefined && document.PubsRotator.Rotator != null && document.PubsRotator.Rotator.length > 0) {
                        document.PubsRotator.Rotator.fadeIn(1000);
                        document.PubsRotator.Cycle();
                    }
                    else {
                        GeneralSearch.iFrameHomePageContainer.fadeIn(1000);
                    }
                }
            });
            $('#EncounterOptionsMenu').remove();
            $('#BracketHeaderMenu').remove();
        }
        function ClearTimers() {
            timeOutCount = timeOutMax;
            timeOutMessage.hide();
            if (timeoutmessageID != null) {
                window.clearTimeout(timeoutmessageID);
            }
            if (timeoutID != null) {
                window.clearTimeout(timeoutID);
            }
        }
        function ShowCloseDialog() {
            $("#dialog-confirm").dialog({
                resizable: false,
                height: 140,
                modal: true,
                buttons: {
                    "Delete all items": function () {
                        $(this).dialog("close");
                    },
                    Cancel: function () {
                        $(this).dialog("close");
                    }
                }
            });
        }
        function SetTimer() {
            if (GeneralSearch.callFromHomePage == "True") {
                return;
            }
            if (Desktop.waitingForTimeOut) {
                ClearTimers();
                timeoutID = window.setTimeout(DisplayTimeOutMessage, (timeOutInSecond - timeOutMax) * 1000);
            }
        }
        Desktop.SetTimer = SetTimer;
        function DisplayTimeOutMessage() {
            UpdateTimeOutMessage(timeOutMessage);
            if (timeOutCount <= timeOutMax) {
                timeOutMessage.show();
            }
            if (timeOutCount > 0) {
                timeoutmessageID = window.setTimeout(DisplayTimeOutMessage, 1000);
                timeOutCount -= 1;
            }
            else {
                timeOutMessage.stop(true, true);
                //Dans clearresult, y a clear timeout et il cache le message
                ClearResult();
            }
        }
        function UpdateTimeOutMessage(element) {
            $('em', element).html(timeOutCount);
        }
        //Commente le scan, invalid scan est triggered pour rien si tape trop vite
        //var searchScanHelper = new CS.ScanEntryHelper();
        //searchScanHelper.Scan = function (speed) {
        //    CS.trigger('Scanned', CS.body);
        //    if (selectedEntityIdAutoComplete.data('context').AutoComplete.val() != "") {
        //        OnSearchScanned(searchScanHelper.Input);
        //    }
        //};
        //CS.on('keyup', function (e) {
        //    let key = window.event ? e.keyCode : e.which;
        //    e.preventDefault();
        //    searchScanHelper.GrabInput(key);
        //});
        function OnSearchScanned(scannedId) {
            SearchPlayerExternalIdScanned(scannedId, function (valid, entityBaseId, externalId) {
                var autoCompleteContext = selectedEntityIdAutoComplete.data('context');
                autoCompleteContext.ClearValue();
                //autoCompleteContext.val(-1, '');
                autoCompleteContext.Close();
                if (valid) {
                    GeneralSearch.SelectedEntity(entityBaseId);
                }
                else {
                    var popup = CompuSport.Controls.Popup.ShowWarningDialog("The scanned code is invalid!!");
                    popup.OnClosed = function () {
                        selectedEntityIdAutoComplete.data('context').AutoComplete.clearAndFocus();
                    };
                }
            });
        }
        function SearchPlayerExternalIdScanned(externalId, callback) {
            CompuSport.Ajax.Get(CSParameters.ControllerUrl + "PlayerExternalIdScanned/" + CSParameters.SportEventId, { externalId: externalId }, function (response) {
                if (response == '') {
                    callback(false, 0, null, null);
                }
                else {
                    callback(true, response.entityBaseId, response.externalId, response.displayName);
                }
            });
        }
    })(Desktop = GeneralSearch.Desktop || (GeneralSearch.Desktop = {}));
})(GeneralSearch || (GeneralSearch = {}));
var FindByPopup;
(function (FindByPopup) {
    var $OkButton;
    var $FindByPopupDiv;
    CS.FormReady(function (formId) {
        if (formId == "FindByPopupcs-form") {
            //(<any>document).stateId.SelectionChange = RefreshGrid;
            $("#stateId").controlIsLoaded(function (stateId) {
                stateId.SelectionChange = RefreshGrid;
            });
            $("#countryId").controlIsLoaded(function (countryId) {
                countryId.SelectionChange = RefreshGrid;
            });
            document.operatorId.SelectionChange = RefreshGrid;
            $("#divisionId").controlIsLoaded(function (divisionId) {
                divisionId.SelectionChange = RefreshGrid;
            });
            //(<any>document).divisionId.SelectionChange = RefreshGrid;
            $("input[name=Discriminator]:radio", $FindByPopupDiv).on('CSChange', function () {
                RefreshGrid.call(this);
            });
            var popup = $('#FindByPopupForm').parents(".ui-dialog");
            var okButton = $($('.ui-button', popup).not('.ui-dialog-titlebar-close')[0]);
            okButton.hide();
            document.GridViewEntityBaseFilteredSearchv2.SelectionChange = function () {
                if (document.GridViewEntityBaseFilteredSearchv2.SelectedRows.length == 1) {
                    okButton.show();
                }
                else {
                    okButton.hide();
                }
            };
        }
    });
    function RefreshGrid() {
        document.GridViewEntityBaseFilteredSearchv2.RefreshGridData();
    }
})(FindByPopup || (FindByPopup = {}));

//# sourceMappingURL=GeneralSearch.desktop.js.map
